import React from 'react';
import appLogo from '../../assets/app-logo.png';
import './WorldStatsFlagsShareCard.css';

/**
 * Share block showing user's travel stats: flags grid, VOIA branding, world %, countries, continents.
 * Optional: card style, logo, username (e.g. hidden on profile fallback page).
 */
const WorldStatsFlagsShareCard = ({
  username,
  worldPercentage,
  countriesCount,
  continentsCount,
  countryCodes = [],
  card = true,
  showLogo = true,
  showUsername = true,
  compactFlags = false,
}) => {
  const hasStats = worldPercentage != null || countriesCount != null || continentsCount != null;
  const hasFlags = Array.isArray(countryCodes) && countryCodes.length > 0;

  const baseUrl = process.env.PUBLIC_URL || '';
  const defaultFlagUrl = `${baseUrl}/assets/images/flags/default-flag.webp`;
  const flagUrl = (code) => {
    const c = (code && String(code).toLowerCase().slice(0, 2)) || '';
    if (!c) return defaultFlagUrl;
    return `${baseUrl}/assets/images/flags/${c}.webp`;
  };

  const handleFlagError = (e) => {
    e.target.onerror = null;
    e.target.src = defaultFlagUrl;
  };

  const rootClass = [
    'world-stats-share-card',
    !card && 'world-stats-share-card--inline',
    compactFlags && 'world-stats-share-card--compact-flags',
  ].filter(Boolean).join(' ');

  return (
    <div className={rootClass}>
      {hasFlags && (
        <div className="world-stats-share-card__flags">
          {countryCodes.slice(0, 30).map((code, i) => (
            <div key={`${code}-${i}`} className="world-stats-share-card__flag-wrap">
              <img
                src={flagUrl(code)}
                alt=""
                className="world-stats-share-card__flag"
                loading="lazy"
                fetchPriority={i < 6 ? 'high' : 'low'}
                onError={handleFlagError}
              />
            </div>
          ))}
        </div>
      )}
      {hasStats && (
        <div className="world-stats-share-card__stats">
          {worldPercentage != null && (
            <>
                <div className="world-stats-share-card__stat">
                  <span className="world-stats-share-card__stat-value">{Math.round(worldPercentage)}%</span>
                  <span className="world-stats-share-card__stat-label">World</span>
                </div>
              {(countriesCount != null || continentsCount != null) && (
                <div className="world-stats-share-card__stat-divider" aria-hidden="true" />
              )}
            </>
          )}
          {countriesCount != null && (
            <>
                <div className="world-stats-share-card__stat">
                  <span className="world-stats-share-card__stat-value">{countriesCount}</span>
                  <span className="world-stats-share-card__stat-label">Countries</span>
                </div>
              {continentsCount != null && (
                <div className="world-stats-share-card__stat-divider" aria-hidden="true" />
              )}
            </>
          )}
          {continentsCount != null && (
            <div className="world-stats-share-card__stat">
              <span className="world-stats-share-card__stat-value">{continentsCount}</span>
              <span className="world-stats-share-card__stat-label">Continents</span>
            </div>
          )}
        </div>
      )}
      {showLogo && (
        <div className="world-stats-share-card__logo-wrap">
          <img src={appLogo} alt="VOIA" className="world-stats-share-card__logo" />
        </div>
      )}
      {showUsername && username && (
        <p className="world-stats-share-card__username">
          @{username.replace(/^@/, '')}
        </p>
      )}
    </div>
  );
};

export default WorldStatsFlagsShareCard;
